<div class="import-folder">
  <div class="import-folder-row">
    <div class="import-folder-row-title" (click)="isOpen = !isOpen">
      <fw-icon class="import-folder-row-title-expand-icon icon" [class.open]=isOpen size="medium"
        [color]="isOpen  ? 'primary' : 'typography'">
        chevron-forward
      </fw-icon>
      <fw-icon class="icon" size="medium"
        [color]="isOpen  ? 'primary' : 'typography'">{{isOpen  ? 'folder-open' : 'folder-blank'}}</fw-icon>
      <div [matTooltip]="folder.name" matTooltipClass="break-word" class="import-folder-row-title-name">
        {{ folder.name }}
      </div>
    </div>
    <div class="import-folder-row-contains">
      {{ folder.fileCount }} item{{ folder.fileCount > 1 ? 's' : '' }}
    </div>
    <div class="import-folder-row-size">
      {{ folder.size | storageUnit }}
    </div>
    <div class="import-folder-row-status">
      <fw-chip [color]="getStatusClassFn(folder.status)" [title]="folder.status"
        [matTooltip]="(folder.completedPartsSize | storageUnit) + ' completed'">
      </fw-chip>
    </div>
    <div class="import-folder-row-remove">
      <fw-icon-button *ngIf="folder.status === fileStatusEnum.Error && folder.hasRetryableError" icon="rotate-refresh"
        size="small" (click)="retryFolder.emit(folder)"
        [matTooltip]="'localImport.fileStatus.labels.retryUpload' | translate"></fw-icon-button>
      <fw-icon-button icon="close-circled" color="slate" size="small" (click)="cancelFolder.emit(folder)"
        [matTooltip]="'localImport.fileStatus.labels.cancelUpload' | translate"></fw-icon-button>
    </div>
  </div>
  <div *ngIf="isOpen">
    <local-import-table-folder-row class="import-folder-folder"
      *ngFor="let folder of (folder.dirList | alphaNumericSort: 'name'); trackBy: trackByForFolderFn" [folder]="folder"
      [status]="folder.status" (retryFile)="retryFile.emit($event)" (cancelFile)="cancelFile.emit($event)"
      (cancelFolder)="cancelFolder.emit($event)"
      (retryFolder)="retryFolder.emit($event)"></local-import-table-folder-row>
    <local-import-table-file-row class="import-folder-file"
      *ngFor="let file of (folder.files | alphaNumericSort: 'fileName'); trackBy: trackByForFileFn" [file]="file"
      [status]="file.status" (retry)="retryFile.emit($event)" [completedPartsSize]="file.completedPartsSize"
      (cancel)="cancelFile.emit($event)"></local-import-table-file-row>
  </div>
</div>
